"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetError = void 0;
const Enums_1 = require("./Enums");
class NetError extends Error {
    constructor(code, message, skipProccessing = false) {
        let text = message;
        if (!text)
            if (NetError.ErrorMessages.has(code))
                text = NetError.ErrorMessages.get(code);
        if (!text)
            text = `Network error with code=${code}`;
        super(text);
        this.code = code;
        this.skipProccessing = skipProccessing;
    }
}
exports.NetError = NetError;
NetError.ErrorMessages = new Map([
    [Enums_1.HTTPCodes.ConnectionTimedOut, "Connection timed out! Check your connection to network."],
    [Enums_1.HTTPCodes.BadDataFormat, "Wrong data format."],
    [Enums_1.HTTPCodes.UnknownResponse, "Unknown response from server."],
]);
//# sourceMappingURL=NetError.js.map